import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getHelpSettings } from '../../../services/helpSettings.service'
import { FacebookIcon, InstagramIcon, WhatsAppIcon } from '../../../components/icons/SocialIcons'
import { buildWhatsAppLinkAR } from '../../../utils/whatsapp'

function FashionFooter() {
  const [help, setHelp] = useState(null)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      try {
        const data = await getHelpSettings()
        if (mounted) setHelp(data)
      } catch (e) {
        if (mounted) setHelp(null)
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [])

  const social = help?.contact?.socialMedia || {}
  const whatsappLink = buildWhatsAppLinkAR(social?.whatsapp)
  const hasInstagram = !!social?.instagram
  const hasFacebook = !!social?.facebook
  const hasWhatsapp = !!whatsappLink

  return (
    <footer className="w-full bg-[#e8e6e1] py-16 mt-20">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h4 className="font-bold text-lg mb-6">Tienda</h4>
          <ul className="flex flex-col gap-3 text-sm text-gray-600">
            <li><Link className="hover:text-[#c27e70] transition-colors" to="/productos">Novedades</Link></li>
            <li><Link className="hover:text-[#c27e70] transition-colors" to="/productos">Vestidos</Link></li>
            <li><Link className="hover:text-[#c27e70] transition-colors" to="/productos">Abrigos</Link></li>
            <li><Link className="hover:text-[#c27e70] transition-colors" to="/productos">Accesorios</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-6">Ayuda</h4>
          <ul className="flex flex-col gap-3 text-sm text-gray-600">
            <li><Link className="hover:text-[#c27e70] transition-colors" to="/ayuda">Preguntas Frecuentes</Link></li>
            <li><Link className="hover:text-[#c27e70] transition-colors" to="/ayuda">Envíos y Devoluciones</Link></li>
            <li><Link className="hover:text-[#c27e70] transition-colors" to="/contacto">Contacto</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-lg mb-6">Redes</h4>
          <div className="flex gap-4 mb-6">
            {hasInstagram ? (
              <a className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:text-[#c27e70] transition-colors shadow-sm" href={social.instagram} target="_blank" rel="noreferrer">
                <InstagramIcon className="w-5 h-5" />
              </a>
            ) : null}
            {hasFacebook ? (
              <a className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:text-[#c27e70] transition-colors shadow-sm" href={social.facebook} target="_blank" rel="noreferrer">
                <FacebookIcon className="w-5 h-5" />
              </a>
            ) : null}
            {hasWhatsapp ? (
              <a className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:text-[#c27e70] transition-colors shadow-sm" href={whatsappLink} target="_blank" rel="noreferrer">
                <WhatsAppIcon className="w-5 h-5" />
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default FashionFooter
